export enum AuthType {
  ADMIN,
  SMS,
  PASSWORD,
  TELEGRAM,
  WHATSAPP,
  ANY,
  EMAIL,
}
